import { memo, type MouseEvent } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { usePaymentMethodsContext } from "../../PaymentMethodsProvider";
import { usePaymentMethodContext } from "../PaymentMethodProvider";

const DuplicatePaymentMethodButton = () => {
    const { getPaymentMethod } = usePaymentMethodContext();
    const { requestDuplicate } = usePaymentMethodsContext();

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();
        requestDuplicate(getPaymentMethod());
    };

    const stopPropagation = (event: MouseEvent | React.FocusEvent | React.KeyboardEvent) => {
        event.stopPropagation();
    };

    return (
        <Tooltip
            title='Duplicate'
            placement='top'
        >
            <IconButton
                size='small'
                aria-label='Duplicate payment method'
                onClick={handleClick}
                onMouseDown={stopPropagation as any}
                onFocus={stopPropagation as any}
                onKeyDown={stopPropagation as any}
            >
                <ContentCopyIcon
                    fontSize='small'
                />
            </IconButton>
        </Tooltip>
    );
};

export default memo(DuplicatePaymentMethodButton);
